import React from 'react';
import PropTypes from 'prop-types';
import Picture from '@deporvillage/picture-component';
import ProductItem, { ProductItemWrapper } from '@deporvillage/product-item-component';
import { I18n } from '@deporvillage/utils-library-component';

import styles from './AutocompleteGrid.module.scss';

const AutocompleteGridClick = {
    Brand: 'brand',
    Category: 'category',
    All: 'all',
    Close: 'close',
    Item: 'item',
};

const BrandGrid = ({ brands, onClick }) => (
    <div className={styles['brand-grid-component']}>
        <div className={styles['title']}>
            <I18n>header.search.autocomplete.brands</I18n>
            {brands.map((b, idx) => (
                <span key={b.name} className={styles['brand-grid-item']}>
                    <a data-testid={`brand-item-${idx}`} href={b.url} title={b.name} onClick={onClick}><Picture src={`/brand/logo/bw/${b.image}`}
                        name={b.name} width={60} height={60} lazy /></a>
                </span>
            ))}
        </div>
    </div>
);

BrandGrid.propTypes = {
    brands: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            image: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
};

const CategoryGrid = ({ categories, onClick }) => (
    <div className={styles['category-grid-component']}>
        <p className={styles['title']}>
            <I18n>header.search.autocomplete.categories</I18n>
        </p>
        {categories.map((c, idx) => (
            <div key={c.name} className={styles['category-grid-item']}>
                <a data-testid={ `category-item-${idx}`} href={c.url} title={c.name} onClick={onClick}>{c.name}</a>
            </div>
        ))}
    </div>
);

CategoryGrid.propTypes = {
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    onClick: PropTypes.func,
};


const GridItem = ({ item, query, onClick }) => (
    <div className={styles['grid-item-component']}>
        <ProductItemWrapper>
            <a href={`${item.url}?=${query}`} title={item.title} onClick={onClick}>
                <ProductItem item={item} />
            </a>
        </ProductItemWrapper>
    </div>
);
GridItem.propTypes = {
    item: PropTypes.object,
    query: PropTypes.string,
    onClick: PropTypes.func,
};

const AutocompleteGrid = ({ query, count, items, categories, brands, onClick, onSubmit, onClose }) => {
    let totalItems = items;
    if (categories && categories.length && items.length === 7) totalItems = totalItems.slice(0, 6);

    const handleClickBrand = () => onClick && onClick(AutocompleteGridClick.Brand);
    const handleClickCategory = () => onClick && onClick(AutocompleteGridClick.Category);
    const handleClickButton = (ev) => onSubmit && onSubmit(ev, AutocompleteGridClick.All);
    const handleClickClose = () => onClose && onClose(AutocompleteGridClick.Close);

    return (
        <div className={styles['autocomplete-grid-component']} data-testid={'autocomplete-collection'}>
            <div className={styles['autocomplete-grid-wrapper']}>
                <div className={styles['autocomplete-grid-title']}>
                    <I18n args={{ query }}>header.search.autocomplete.title</I18n>
                    <span data-testid='icon-close' className={'icon icon-close'} onClick={handleClickClose} />
                </div>
                {brands && brands.length ? (
                    <div className={styles['autocomplete-grid-brands']}>
                        <BrandGrid brands={brands} onClick={handleClickBrand} />
                    </div>
                ) : null}
                <div
                    className={
                        `${styles[`autocomplete-grid-items`]} ${categories && categories.length ? styles['has-categories'] : ''} ${brands && brands.length ? styles['has-brands'] : ''}`
                    }
                >
                    {categories && categories.length ? (
                        <CategoryGrid categories={categories} onClick={handleClickCategory} />
                    ) : null}
                    {totalItems.map((i) => (
                        <GridItem key={i.id} item={i} query={query} onClick={() => onClick && onClick(AutocompleteGridClick.Item, i)} />
                    ))}
                </div>
                <div className={styles['autocomplete-grid-action']}>
                    <button onClick={handleClickButton} className={styles['autocomplete-button']}>
                        <I18n args={{ total: count }}>header.search.autocomplete.show</I18n>
                    </button>
                </div>
            </div>
        </div>
    );
};
AutocompleteGrid.propTypes = {
    query: PropTypes.string,
    count: PropTypes.number,
    items: PropTypes.array,
    categories: PropTypes.array,
    brands: PropTypes.array,
    onClick: PropTypes.func,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
};

export default AutocompleteGrid;
export { AutocompleteGridClick };
